import React, { useState } from "react";
import { pdfjs, Document, Page } from 'react-pdf';

//react-pdf styles
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Row, } from "reactstrap";
import jsonWorker from "./vendor/pdf.worker.min.json";
// #ux-redesign: LoadingLocal → LoadingBlock del DS
import { LoadingBlock } from "components/ds";

/*Import pdf worker as a JSON file, then convert to blob and generate a valid URL 
(Firefox does not load invalid MIME types like mjs)*/
var workerBlob = new Blob([jsonWorker],{type : 'text/javascript'});
var workerBlobURL = URL.createObjectURL(workerBlob);

//react-pdf worker config
pdfjs.GlobalWorkerOptions.workerSrc = workerBlobURL; //`//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ReportViewerRenderer = ({
    file,
    setNumPages,
    pageHeight,
    setPageHeight,
    pageNumber,
    setLoadingPDF,
    zoom = 1,
 }) => {

    // #ux-redesign: width responsive — usa el ancho del contenedor (max 1080)
    // y aplica el zoom del toolbar como multiplicador.
    const baseWidth = typeof window !== 'undefined' && window.visualViewport
      ? Math.min(window.visualViewport.width, 1080)
      : 800;
    const width = (baseWidth / 1.4) * zoom;

    const onDocumentLoadSuccess = async (pdf) => {
        setLoadingPDF(false);
        const heightOfPage = await pdf
          .getPage(1)
          .then((page) => page.getViewport({ scale: 1.4 }).height);
        setNumPages(pdf.numPages);
        setPageHeight(heightOfPage);
    };

    const isLoading = () => {
        setLoadingPDF(true);
        return <LoadingBlock />;
    };

    return (
      <>
        {file && (
          <div className="ds-pdfviewer__page-inner" style={{ minHeight: `${pageHeight}px` }}>
            <Document
              file={{ data: file }}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={isLoading}
            >
              <Page
                width={width}
                pageNumber={pageNumber}
                renderAnnotationLayer={false}
                renderTextLayer={false}
              />
            </Document>
          </div>
        )}
      </>
    );
};

export default React.memo(ReportViewerRenderer);